import classNames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { IInputWrapProps, InputStyles, InputWrap } from 'core-components/library/inputs'

export interface ITranslationInputWrapProps extends IInputWrapProps {
  translation?: string
}

export const TranslateInputWrap = (props: ITranslationInputWrapProps) => {
  const translationMode = useSelector(selectTranslationMode)
  const isTranslationMode = translationMode === TranslationMode.Edit

  return (
    <InputWrap
      {...props}
      customTemplates={{
        root: () => {
          const showDefaultTemplate =
            !props.translation || (props.translation && !isTranslationMode)
          if (!showDefaultTemplate) {
            return (
              <div className={classNames(InputStyles.content, props.classes?.content || '')}>
                <Translation text={props.translation || ''} actionsInside disableBorder />
              </div>
            )
          }
          return false
        },
        labelRoot: () => !!props.label || !!props.translation,
        labelContent: () => {
          if (props.translation) {
            return <Translation text={props.translation} span disabled />
          }
          return false
        },
      }}
    />
  )
}
